import React, { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import api from "../../api/axios";
import { cn } from "../../lib/utils";
import { qrStickerOnWhite } from "../../utils/qrStickerOnWhite";

/** Downloads the owner's sticker artwork ("Emergency QR", "SCAN ME", QR ID) — the same image that is printed. */
const DownloadStickerButton = ({ className }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const handleDownload = async () => {
    setBusy(true);
    setError(null);
    try {
      const res = await api.get("/qr/me/qr-code");
      const { qrId, qrCode } = res.data || {};
      if (!qrCode) throw new Error("missing image");
      const link = document.createElement("a");
      link.href = await qrStickerOnWhite(qrCode);
      link.download = `EmergencyQR-${qrId}.png`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (_) {
      setError("Couldn't download the QR. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className={cn("checkout-btn checkout-btn--secondary gap-2 whitespace-nowrap justify-center", className)}
        onClick={handleDownload}
        disabled={busy}
      >
        {busy ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />}
        Download
      </button>
      {error && <p className="text-destructive text-sm m-0 w-full">{error}</p>}
    </>
  );
};

export default DownloadStickerButton;
